import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { useLocalStorage } from '../../services/hooks/useLocalStorage';

import { Button } from '@mui/material';

import Header from '../Header';

const useStyles = makeStyles({
    resultContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '400px',
        '& *': {
            margin: '12px'
        }
    },
    header: {
        fontSize: '1.5rem',
        maxWidth: '600px',
        textAlign: 'center'
    },
    subheader: {
        maxWidth: '600px',
        textAlign: 'center'
    },
});

const Error = () => {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const [stratus] = useLocalStorage("stratus", false);
    const ns = stratus ? 'stratus' : 'scantrip';
    const { t } = useTranslation(ns);

    const [user] = useLocalStorage('user', '');
    const [tenant] = useLocalStorage('tenant', undefined);
    const [noDipa] = useLocalStorage("noDipa", false);

    const logout = async () => {
        history.push("/logout");
    }

    const params = new URLSearchParams(location.search);
    const header = params.get('header') || 'An error has occurred.';
    const subheader = params.get('subheader');

    return (
        <div>
            <Header user={user} tenant={tenant?.name} noDipa={noDipa} logout={logout} />
            <div className={classes.resultContainer}>
                <div className={classes.header}>{t(header)}</div>
                <div className={classes.subheader}>{t(subheader)}</div>
                <Button
                    variant="contained"
                    disableElevation
                    onClick={() => history.push('/')}
                    sx={{
                        width: "121px",
                        height: "42px",
                        margin: "32px"
                    }}
                >
                    {t('OK')}
                </Button>
            </div>
        </div>
    )
}

export default Error;
